import portfolio from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import './Header.css'

const Header = () => {
  const { name } = portfolio

  return (
    <header className='header center'>
      <h3>
        <span className='link'>
          {name}
        </span>
      </h3>
      <Navbar />
    </header>
  )
}

export default Header
